import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { TermsAndConditionsComponent } from "../../features/terms-and-conditions/terms-and-conditions.component";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiTermsAndConditionsPageComponent } from "./new-ui-terms-and-conditions-page.component";

@Component({
  selector: "app-terms-and-conditions-page",
  templateUrl: "./terms-and-conditions-page.component.html",
  styleUrl: "./terms-and-conditions-page.component.scss",
  imports: [TranslateDirective, NgIf, TermsAndConditionsComponent],
})
export class TermsAndConditionsPageComponent extends NewUiTermsAndConditionsPageComponent {}
